// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"13":"e06c0f37","187":"0ddc6dfc","658":"cc1bc1b1","926":"37182af7"}[chunkId] + ".js";
};